import React from 'react';

const ContentModerationDashboard = ({ activeTab = 'pending' }) => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>Content Moderation Dashboard</h1>
      <p>Active Tab: {activeTab}</p>
      <p>Content moderation features coming soon...</p>
    </div>
  );
};

export default ContentModerationDashboard;
